export default {
  // Right menu items
  menuItems: {
    nodeNote: {
      text: "Note Node",
      shortcut: "alt+V/⌥+V",
    },
    copyAddress: {
      text: "Copy Address",
      shortcut: "ctrl+C/⌘+C",
    },
    addCanvas: {
      text: "New Canvas",
      shortcut: "alt+G/⌥+G",
    },
    deleteNode: {
      text: "Delete Node",
      shortcut: "Delete",
    },
    labelSetting: {
      text: "Label Settings",
      submenu: {
        addLabel: "Add Label",
        editLabel: "Edit Label",
        deleteLabel: "Delete Label",
      },
    },
    addSurvey: {
      text: "Add Survey",
      submenu: {
        ordinarySurvey: "Normal Survey",
        keySurvey: "Key Survey",
      },
    },
    addMonitor: {
      text: "Add Monitor",
      shortcut: "ctrl+M/⌘+M",
    },
    addBoard: {
      text: "Add to Board",
    },
  },
};
